import React from 'react';
import { chatDateLabel } from '@src/helpers/ChatDateLabel';

interface Props {
	text?: string;
	timestamp?: number;
}

const MessageDateIndicator: React.FC<Props> = ({ text, timestamp }) => {
	return (
		<div className="chat__message__dateContainer">
			<span className="chat__message__dateContainer__indicator">
				{text !== undefined ? text : chatDateLabel(timestamp)}
			</span>
		</div>
	);
};

export default MessageDateIndicator;
